<template>
  <div class="community-space-confirm-container">
    <el-row :gutter="16">
      <!-- 左侧：扫码核销工作台 -->
      <el-col :xs="24" :sm="24" :md="8" :lg="7">
        <div class="ds-panel ds-scan-panel">
          <div class="ds-scan-panel__header">
            <i class="el-icon-camera"></i>
            <span>{{ $t('communitySpaceConfirm.scan.title') }}</span>
          </div>

          <div class="ds-scan-panel__body">
            <el-input v-model.trim="communitySpaceConfirmInfo.timeId" clearable
              :placeholder="$t('communitySpaceConfirm.writeOffPlaceholder')"
              @keyup.enter.native="confirmCommunitySpace">
              <el-button slot="append" type="primary" icon="el-icon-search" @click="confirmCommunitySpace">
                {{ $t('communitySpaceConfirm.writeOff') }}
              </el-button>
            </el-input>
            <p class="ds-scan-panel__tip">{{ $t('communitySpaceConfirm.scan.tip') }}</p>

            <!-- 核销结果卡片 -->
            <div class="ds-result-card">
              <div class="ds-result-card__header">
                <i class="el-icon-circle-check"></i>
                <span>{{ $t('communitySpaceConfirm.writeOffResult') }}</span>
              </div>
              <dl class="ds-result-list">
                <div class="ds-result-list__row">
                  <dt>{{ $t('communitySpaceConfirm.writeOffTime') }}</dt>
                  <dd>{{ communitySpaceConfirmInfo.order.createTime || '-' }}</dd>
                </div>
                <div class="ds-result-list__row">
                  <dt>{{ $t('communitySpaceConfirm.space') }}</dt>
                  <dd>{{ communitySpaceConfirmInfo.order.spaceName || '-' }}</dd>
                </div>
                <div class="ds-result-list__row">
                  <dt>{{ $t('communitySpaceConfirm.appointmentDate') }}</dt>
                  <dd>{{ communitySpaceConfirmInfo.order.appointmentTime || '-' }}</dd>
                </div>
                <div class="ds-result-list__row">
                  <dt>{{ $t('communitySpaceConfirm.appointmentHours') }}</dt>
                  <dd>{{ communitySpaceConfirmInfo.order.hours || '-' }}</dd>
                </div>
                <div class="ds-result-list__row">
                  <dt>{{ $t('communitySpaceConfirm.appointmentPerson') }}</dt>
                  <dd>{{ communitySpaceConfirmInfo.order.personName || '-' }}</dd>
                </div>
                <div class="ds-result-list__row">
                  <dt>{{ $t('communitySpaceConfirm.appointmentPhone') }}</dt>
                  <dd>{{ communitySpaceConfirmInfo.order.personTel || '-' }}</dd>
                </div>
                <div class="ds-result-list__row">
                  <dt>{{ $t('communitySpaceConfirm.remark') }}</dt>
                  <dd>{{ communitySpaceConfirmInfo.order.remark || '-' }}</dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </el-col>

      <!-- 右侧：核销记录列表 -->
      <el-col :xs="24" :sm="24" :md="16" :lg="17">
        <!-- (1) PageHeader -->
        <ds-page-header :title="$t('communitySpaceConfirm.page.title')"
          :subtitle="$t('communitySpaceConfirm.page.subtitle')" />

        <!-- (2) SearchPanel -->
        <ds-search-panel>
          <el-row :gutter="16">
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-input v-model.trim="communitySpaceConfirmInfo.conditions.personName" clearable class="w-full"
                :placeholder="$t('communitySpaceConfirm.personNamePlaceholder')"
                @keyup.enter.native="queryCommunitySpaceConfirm" />
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-input v-model.trim="communitySpaceConfirmInfo.conditions.personTel" clearable class="w-full"
                :placeholder="$t('communitySpaceConfirm.personTelPlaceholder')"
                @keyup.enter.native="queryCommunitySpaceConfirm" />
            </el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="6">
              <el-date-picker v-model="communitySpaceConfirmInfo.conditions.appointmentTime" type="datetime"
                class="w-full" value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$t('communitySpaceConfirm.appointmentTimePlaceholder')" />
            </el-col>
          </el-row>

          <template #actions>
            <el-button type="primary" icon="el-icon-search" @click="queryCommunitySpaceConfirm">
              {{ $t('communitySpaceConfirm.search') }}
            </el-button>
            <el-button icon="el-icon-refresh-left" @click="resetCommunitySpaceConfirm">
              {{ $t('communitySpaceConfirm.reset') }}
            </el-button>
          </template>
        </ds-search-panel>

        <!-- (3)(4)(6) Toolbar + DataTable + PaginationBar -->
        <div class="ds-panel">
          <ds-toolbar :total="pagination.total" :density="density" :show-column-setting="false"
            :show-refresh="true" @update:density="density = $event" @refresh="refreshList">
            <template #left>
              <span class="ds-panel__title">{{ $t('communitySpaceConfirm.list.title') }}</span>
            </template>
          </ds-toolbar>

          <ds-data-table :data="communitySpaceConfirmInfo.orders" :loading="loading" :error="hasError"
            :error-message="errorMessage" :density="density" border
            :empty-description="$t('communitySpaceConfirm.page.empty')" @retry="refreshList">
            <el-table-column prop="orderId" :label="$t('communitySpaceConfirm.writeOffOrder')" align="center" width="170">
              <template slot-scope="scope">
                <span class="ds-num">{{ scope.row.orderId || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="venueName" :label="$t('communitySpaceConfirm.venue')" align="center" width="120" />
            <el-table-column prop="spaceName" :label="$t('communitySpaceConfirm.space')" align="center" width="130" />
            <el-table-column prop="appointmentTime" :label="$t('communitySpaceConfirm.appointmentDate')" align="center"
              width="160">
              <template slot-scope="scope">
                <span class="ds-num">{{ scope.row.appointmentTime || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="hours" :label="$t('communitySpaceConfirm.appointmentTime')" align="center" width="100">
              <template slot-scope="scope">
                <span class="ds-num">{{ scope.row.hours || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="personName" :label="$t('communitySpaceConfirm.appointmentPerson')" align="center"
              width="110" />
            <el-table-column prop="personTel" :label="$t('communitySpaceConfirm.appointmentPhone')" align="center"
              width="130">
              <template slot-scope="scope">
                <span class="ds-num">{{ scope.row.personTel || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('communitySpaceConfirm.writeOffTime')" align="center"
              width="160">
              <template slot-scope="scope">
                <span class="ds-num">{{ formatDateTimeSec(scope.row.createTime) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="remark" :label="$t('communitySpaceConfirm.remark')" align="left" min-width="160"
              show-overflow-tooltip />
          </ds-data-table>

          <ds-pagination-bar :total="pagination.total" :page="pagination.current" :size="pagination.size"
            :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" @current-change="handleCurrentChange">
            <template #summary>
              <span class="ds-tip-text">{{ $t('communitySpaceConfirm.page.tip') }}</span>
            </template>
          </ds-pagination-bar>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  listCommunitySpaceConfirmOrder,
  saveCommunitySpaceConfirmOrder
} from '@/api/community/communitySpaceConfirmApi'
import { getCommunityId } from '@/api/community/communityApi'
import { formatDateTimeSec } from '@/utils/format'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsSearchPanel from '@/components/ds/ds-search-panel.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'

export default {
  name: 'CommunitySpaceConfirmList',
  components: {
    DsPageHeader,
    DsSearchPanel,
    DsToolbar,
    DsDataTable,
    DsPaginationBar
  },
  data() {
    return {
      loading: false,
      hasError: false,
      errorMessage: '',
      density: 'default',
      communitySpaceConfirmInfo: {
        orders: [],
        order: {
          remark: '',
          appointmentTime: '',
          createTime: '',
          hours: '',
          spaceName: '',
          personName: '',
          personTel: ''
        },
        timeId: '',
        conditions: {
          spaceId: '',
          personName: '',
          personTel: '',
          appointmentTime: '',
          communityId: ''
        }
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.communitySpaceConfirmInfo.conditions.communityId = getCommunityId()
    this.listCommunitySpaceConfirms()
  },
  methods: {
    async listCommunitySpaceConfirms() {
      this.loading = true
      this.hasError = false
      this.errorMessage = ''
      try {
        const params = {
          ...this.communitySpaceConfirmInfo.conditions,
          page: this.pagination.current,
          row: this.pagination.size
        }

        const { data, total } = await listCommunitySpaceConfirmOrder(params)
        this.communitySpaceConfirmInfo.orders = Array.isArray(data) ? data : []
        this.pagination.total = total || 0
      } catch (error) {
        console.error('获取核销列表失败:', error)
        this.hasError = true
        this.errorMessage = this.$t('communitySpaceConfirm.page.loadFailed')
      } finally {
        this.loading = false
      }
    },
    /**
     * 刷新当前页（工具条刷新 / 错误态重试）
     */
    refreshList() {
      this.listCommunitySpaceConfirms()
    },
    async confirmCommunitySpace() {
      if (!this.communitySpaceConfirmInfo.timeId) {
        this.$message.warning(this.$t('communitySpaceConfirm.scanTip'))
        return
      }

      try {
        // 扫码协议：ORDER:<支付单号> 整单批量核销；TIME:<timeId> 或裸 timeId 单条核销（兼容老码）
        const data = this._buildSpaceConfirmParam(
          this.communitySpaceConfirmInfo.timeId,
          this.communitySpaceConfirmInfo.conditions.communityId
        )

        const result = await saveCommunitySpaceConfirmOrder(data)
        if (result.code == 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.communitySpaceConfirmInfo.timeId = ''

          // 更新核销结果
          if (result.data && result.data.length > 0) {
            this.communitySpaceConfirmInfo.order = {
              ...result.data[0],
              remark: result.data[0].remark || this.$t('communitySpaceConfirm.writeOffSuccess')
            }
          }

          // 刷新列表
          this.pagination.current = 1
          this.listCommunitySpaceConfirms()
        } else {
          this.$message.error(result)
        }
      } catch (error) {
        console.error('核销失败:', error)
        this.$message.error(error)
      }
    },
    queryCommunitySpaceConfirm() {
      this.pagination.current = 1
      this.listCommunitySpaceConfirms()
    },
    // 解析扫码/手工输入内容，返回核销接口参数
    // ORDER:<支付单号> -> { orderId } 整单批量；TIME:<timeId>/裸timeId -> { timeId } 单条（兼容老码）
    _buildSpaceConfirmParam(rawCode, communityId) {
      const code = (rawCode || '').trim()
      if (/^ORDER:/i.test(code)) {
        return {
          orderId: code.replace(/^ORDER:/i, '').trim(),
          communityId: communityId
        }
      }
      return {
        timeId: code.replace(/^TIME:/i, '').trim(),
        communityId: communityId
      }
    },
    resetCommunitySpaceConfirm() {
      this.communitySpaceConfirmInfo.conditions.personName = ''
      this.communitySpaceConfirmInfo.conditions.personTel = ''
      this.communitySpaceConfirmInfo.conditions.appointmentTime = ''
      this.queryCommunitySpaceConfirm()
    },
    handleSizeChange(size) {
      this.pagination.size = size
      this.pagination.current = 1
      this.listCommunitySpaceConfirms()
    },
    handleCurrentChange(current) {
      this.pagination.current = current
      this.listCommunitySpaceConfirms()
    },
    /**
     * 核销时间格式化（后端返回 "yyyy-MM-dd HH:mm:ss" 字符串）
     */
    formatDateTimeSec(value) {
      return formatDateTimeSec(value)
    }
  }
}
</script>

<style lang="scss" scoped>
.community-space-confirm-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 表格 + 分页 组成的白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

/* 左侧扫码工作台 */
.ds-scan-panel {
  &__header {
    display: flex;
    align-items: center;
    gap: var(--ds-spacing-xs);
    padding: var(--ds-spacing-sm) var(--ds-spacing-lg);
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
    background: var(--ds-gray-50);
    border-bottom: 1px solid var(--ds-gray-300);
  }

  &__body {
    padding: var(--ds-spacing-lg);
  }

  &__tip {
    margin: var(--ds-spacing-sm) 0 0;
    font-size: var(--ds-font-size-xs);
    color: var(--ds-gray-500);
    line-height: 1.6;
  }
}

/* 核销结果卡片 */
.ds-result-card {
  margin-top: var(--ds-spacing-lg);
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  overflow: hidden;

  &__header {
    display: flex;
    align-items: center;
    gap: var(--ds-spacing-xs);
    padding: var(--ds-spacing-sm) var(--ds-spacing-md);
    font-size: var(--ds-font-size-sm);
    font-weight: 600;
    color: var(--ds-primary);
    background: var(--ds-primary-sub);
    border-bottom: 1px solid var(--ds-gray-200);
  }
}

.ds-result-list {
  margin: 0;
  padding: var(--ds-spacing-sm) var(--ds-spacing-md);

  &__row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: var(--ds-spacing-md);
    padding: var(--ds-spacing-xs) 0;
    border-bottom: 1px dashed var(--ds-gray-200);

    &:last-child {
      border-bottom: none;
    }

    dt {
      flex-shrink: 0;
      font-size: var(--ds-font-size-sm);
      color: var(--ds-gray-500);
    }

    dd {
      margin: 0;
      min-width: 0;
      text-align: right;
      word-break: break-all;
      font-size: var(--ds-font-size-sm);
      color: var(--ds-gray-800);
    }
  }
}

/* 分页条左侧提示文案 */
.ds-tip-text {
  font-size: var(--ds-font-size-xs);
  color: var(--ds-gray-500);
  line-height: 1.6;
}
</style>
